var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "events-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M64,16c0,-8.831 -7.169,-16 -16,-16l-32,0c-8.831,0 -16,7.169 -16,16l0,32c0,8.831 7.169,16 16,16l32,0c8.831,0 16,-7.169 16,-16l0,-32Z",
    style: {
      fill: "url(#events-icon-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,20 C14,17.791 15.791,16 18,16 L46,16 C48.209,16 50,17.791 50,20 L50,46 C50,48.209 48.209,50 46,50 L18,50 C15.791,50 14,48.209 14,46 Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,26 L50,26 L50,20 C50,17.791 48.209,16 46,16 L18,16 C15.791,16 14,17.791 14,20 Z",
    style: {
      fill: "url(#events-icon-gradient)",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,12 L22,20 M42,12 L42,20",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 4,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 38,
    r: 4,
    style: {
      fill: "url(#events-icon-gradient)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "events-icon-gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64,64,-64,64,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fbe9b7",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1893ac9610117cb9ffed64a1c58f1d80.svg";
export { ForwardRef as ReactComponent };